import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {setLicenseKey} from '@mescius/wijmo';
// en / ja の両方を読み込み、ja を既定にする (言語切替時は LanguageService が changeCultureSync で差し替える)
import '@mescius/wijmo.cultures/wijmo.culture.en';
import '@mescius/wijmo.cultures/wijmo.culture.ja';

import {AppModule} from './app/app.module';

// Wijmo (Mescius) ライセンス。cosbeni.portal と同形で host ごとに個別キーを
// runtime で選択する (キーは host ロック)。dev.active-promotion.jp /
// active-promotion.jp 用のキーは Mescius 管理画面で発行して追記すること。
// キーが無い host では eval モード (ウォーターマーク表示) で動く。
// Mescius 発行のキーは dev.active-promotion.jp / active-promotion.jp の両ホスト対応
// (キー先頭に対象ホストが埋め込まれている)。両 hostname に同じキーを割り当てる。
const AP_WIJMO_LICENSE =
  'dev.active-promotion.jp|active-promotion.jp,835942938566117#B0gcIbmJCLiIjd6IDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPBh4LZVTbIVHdEpkUMVVU4UVeZBVRVRXTFtGW6hDMyA5Kk5ETVhkNmVzZtlmN9pUM7wWdttEWKdXWFlFOhp4SMhmSplDVwB5Tad4VtJlR5ZFdNR4ULNlVoRXbhNDSK56NrM7Vr2SW9FUWldXOuNUNPNWb7NDeXhHaOR5MkZnbXBTewdEVLlWaVNEbC94axx6aKpWYRplTBpkZt3icKRHUwgXO9UjWi5WR7pFS7BzaORlTUtEbqZGNlJFNTxmMjxUR7NXdCtWT8hVZ7N5TPtmMKtGNptWR8gDVWNTOv3mM7pERrVEWsBTV4V4VQNURsZUMSlHaRZ5NlFXbt5WQGhnaDlnQnh5ZRlkYwdXNQd6dPNUQ5VEZMRUdFJFex3SQYplMRhHWsp5d6g7aoF4bZ9GMYZmbw3kSrIVNwxGc7UkMnh4TthUVSZHSYljM7M5ZmVWVNdjNqBFTiojITJCLikTMGVER9QENiojIIJCLwMzN9UDNyUzM0IicfJye#4XfiQHb5FmZlRmI0IycyZlIs4VfikEMyIlI0IyQiwiIu3Waz9WZ4hXRgACdlVGaThXZsZEIv5mapdlI0IiTisHL3JSNJ9UUiojIDJCLi86bpNnblRHeFBCIyV6dllmV4J7bwVmUg2Wbql6ViojIOJyes4nILdDOIJiOiMkIsIibvl6cuVGd8VEIgc7bSlGdsVXTg2Wbql6ViojIOJyes4nI4YkNEJiOiMkIsIibvl6cuVGd8VEIgAVQM3EIg2Wbql6ViojIOJyes4nIzMEMCJiOiMkIsISZy36Qg2Wbql6ViojIOJyes4nIVhzNBJiOiMkIsIibvl6cuVGd8VEIgQnchh6QsFWaj9WYulmRg2Wbql6ViojIOJyebpjIkJHUiwiIyITNzgDMgkDM9AjNyAjMiojI4J7QiwiIwpmLu3Wa43WbvJHctUmdpR7YhxCcq9ibvlGdv56byBXLlZXa4NWYuYXZkJiOiMXbEJCLis8gjn9gjnrgjPrgj1LpnrJvk/IvlrKomLiOiEmTDJCLicTMxYjN5gzM9IDN9UzM8IiOiQWSiwSfLtDO';
const WIJMO_LICENSES: Record<string, string> = {
  'dev.active-promotion.jp': AP_WIJMO_LICENSE,
  'active-promotion.jp': AP_WIJMO_LICENSE,
};
const hostLicense = WIJMO_LICENSES[window.location.hostname];
if (hostLicense) {
  setLicenseKey(hostLicense);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
